import { Button, Col, Form, Input, message, Row, Select } from "antd";
import { FaPlus } from "react-icons/fa";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { axios } from "../../../../../utils/useAxios";
import { getToken, URL_API } from "../../../../../utils";
import SelectAllType from "../../../../../components/SelectAllType";

const FilterEvent = ({ form, list, setSearchParams }) => {
  const { getFieldDecorator } = form;

  const history = useHistory();
  const match = useRouteMatch();
  const [loading, setLoading] = useState(false);
  const [listChannel, setListChannel] = useState([]);

  const handleChange = useCallback((data) => {
    setSearchParams((prev) => ({
      ...prev,
      ...data,
      offset: 0,
    }));
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${URL_API}/channel`, {
        params: { sort: "updateDate" },
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      setListChannel(res.data);
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <Form>
      <Row gutter={16} className="mb-3">
        <Col md={5}>
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(
              "event_id",
              {},
            )(
              <Select
                className="w-100"
                placeholder="งาน"
                onChange={(value) => handleChange({ event_id: value })}
                loading={loading}
              >
                <Select.Option value="">ทั้งหมด</Select.Option>
                {listChannel?.data?.map((e) => (
                  <Select.Option key={e.id} value={e.id}>
                    {e.title}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Col>
        <Col md={5}>
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(
              "source",
              {},
            )(
              <SelectAllType
                process_type="channel_source"
                withAll
                allText="ทั้งหมด"
                placeholder="แหล่งที่มา"
                className="w-100"
                allowClear
                onChange={(value) => handleChange({ source: value })}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className="mb-3">
        <Col md={16}>
          <Form.Item>
            {getFieldDecorator(
              "search",
              {},
            )(
              <Input.Search
                placeholder="ชื่องาน, Prefix Serial"
                onSearch={(value) => handleChange({ search: value })}
                allowClear
              />,
            )}
          </Form.Item>
        </Col>
        <Col md={4}>
          <Button
            type="primary"
            block
            onClick={() => history.push(`/events/legacy-channel/create`)}
          >
            <FaPlus className="mr-2" />
            Create Event
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Form.create()(FilterEvent);
